import { useMutation } from '@tanstack/react-query';
import { FeaturesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeaturesControllerToggleFeatureStateMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['featuresControllerToggleFeatureState', accessControlScope],
        mutationFn: async (args) => {
            const api = new FeaturesApi(accessControlConfig);
            return api.featuresControllerToggleFeatureState(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeaturesControllerToggleFeatureStateMutation.js.map